import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendCasoPorId,
  BackendListaTareasAbiertasPorIdUsuario,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/ObtenerTareasAbiertasUsuario.json";
import mock_CasosActivoPorId from "../../../dataJson/casosActivoPorId.json";
import { iClientesAdministrados } from "../../../interfaces/backendApi/clientesAdministrados";
import {
  formatDescripcion,
  formatearMensajeBackend,
  ordenarTareas,
  procesarPrioridades,
  shouldRenderTicket,
} from "../../../apis/helper/helperApi";
import { iListTaskHumanUserId } from "../../../interfaces/bonita/listTaskHumanUserId";
import { iCasoActivo } from "../../../interfaces/bonita/casoActivo";
import { formatearFechaCustom } from "../../../components/common/helper/formatoFecha";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  listaTareasAbiertasPorIdUsuario: any[];
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  listaTareasAbiertasPorIdUsuario: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const listaTareasAbiertasPorIdUsuarioSlice = createSlice({
  name: "listaTareasAbiertasPorIdUsuario",
  initialState,
  reducers: {
    setListaTareasAbiertasPorIdUsuario: (
      state,
      action: PayloadAction<{ datos: any[]; numPagina: number }>,
    ) => {
      const { datos, numPagina } = action.payload;

      // Si la página es 1, reemplazamos los datos, si no, concatenamos con los existentes
      if (numPagina === 0) {
        state.listaTareasAbiertasPorIdUsuario = datos;
      } else {
        state.listaTareasAbiertasPorIdUsuario = [
          ...state.listaTareasAbiertasPorIdUsuario,
          ...datos,
        ];
      }
    },
    getListaTareasAbiertasPorIdUsuario: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state.listaTareasAbiertasPorIdUsuario = action.payload;
    },
    setClearListaTareasAbiertasPorIdUsuario: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

const procesarTareasAbiertasPorIdUsuario = async (casos: any[]) => {
  return await Promise.all(
    casos.map(async (caso) => {
      const { priority, alarma, descripcion, ticketRedmine, ci } = caso;
      let partesResumen = [];
      if (priority) {
        partesResumen.push(`Prioridad: ${priority}`);
      }
      if (alarma) {
        partesResumen.push(`Titulo: ${alarma}`);
      }
      if (descripcion) {
        const value = formatDescripcion(descripcion);
        partesResumen.push(`Descripción: ${value}`);
      }
      if (ci) {
        partesResumen.push(`Ci: ${ci}`);
      }

      const renderTicketRedmine = shouldRenderTicket(ticketRedmine);

      if (renderTicketRedmine) {
        partesResumen.push(`Ticket Redmine Nro: ${ticketRedmine}`);
      }
      const resumen =
        partesResumen.length > 0
          ? partesResumen.join("\n\n")
          : "No pudimos obtener los datos del caso";

      return {
        ...caso,
        resumen,
      };
    }),
  );
};

export const setBackendListaTareasAbiertasPorIdUsuario =
  (
    UsuarioBonitaRM: number,
    cliente_id: number,
    clientesAdministrados: iClientesAdministrados[],
    Cantidad: number,
    NumPagina: number,
  ): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    let arrayResponseData: iListTaskHumanUserId[] = [];
    let arrayCasosActivoPorId: iCasoActivo[] = [];
    const clientePorId = clientesAdministrados.filter(
      (item) =>
        item.IdCliente === Number(cliente_id) ||
        item.IdCliente === Number(UsuarioBonitaRM),
    );

    dispatch(setIsLoading(true));
    let response: AxiosResponse = defaultResp;
    let response2: AxiosResponse = defaultResp;
    try {
      if (clientePorId.length > 0) {
        for (const obj of clientePorId) {
          for (const id of obj.UsuariosBonita) {
            if (Number(id) > 0) {
              response = await BackendListaTareasAbiertasPorIdUsuario(
                Number(id),
                Cantidad,
                NumPagina,
              );
              arrayResponseData = [...arrayResponseData, ...response.data.Data];
            }
          }
        }
      }

      if (arrayResponseData.length > 0) {
        for (const obj of arrayResponseData) {
          if (Number(obj.caseId) > 0) {
            response2 = await BackendCasoPorId(Number(obj.caseId));
            arrayCasosActivoPorId = [
              ...arrayCasosActivoPorId,
              ...response2.data.Data,
            ];
          }
        }
      }
      arrayResponseData.forEach((tarea: iListTaskHumanUserId) => {
        // Busca si hay algún caso con el mismo caseId que la tarea actual
        const casoCorrespondiente = arrayCasosActivoPorId.find(
          (caso: iCasoActivo) => caso.id === tarea.caseId,
        );
        // Si se encuentra un caso correspondiente, asigna su responsable a la tarea
        if (casoCorrespondiente) {
          tarea.responsable = casoCorrespondiente.Usuario; // Aquí debes poner el campo correspondiente
        } else {
          tarea.responsable = "No hay responsable";
        }
      });

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        let ordenarLista = [...arrayResponseData];
        ordenarLista = procesarPrioridades(ordenarLista);
        ordenarLista.sort(ordenarTareas);
        ordenarLista = ordenarLista.map((e) => ({
          ...e,
          assigned_date: formatearFechaCustom(e.assigned_date),
          dueDate: formatearFechaCustom(e.dueDate),
          reached_state_date: formatearFechaCustom(e.reached_state_date),
          last_update_date: formatearFechaCustom(e.last_update_date),
        }));

        let listaFormateada =
          await procesarTareasAbiertasPorIdUsuario(ordenarLista);
        dispatch(
          setListaTareasAbiertasPorIdUsuario({
            datos: listaFormateada,
            numPagina: NumPagina,
          }),
        );
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));
        let arrayResponseData: any[] = mock_Json.Data;
        let arrayCasosActivoPorId: any[] = mock_CasosActivoPorId.Data;
        let response: AxiosResponse = defaultResp;
        response.data = mock_Json;
        if (clientePorId.length > 0) {
          for (const obj of clientePorId) {
            for (const id of obj.UsuariosBonita) {
              if (Number(id) > 0) {
                const responsable = mock_CasosActivoPorId.Data[0].Usuario;

                response.data.Data = response.data.Data.map((item: any) => {
                  return {
                    ...item,
                    responsable: responsable,
                  };
                });
                let responseData = response.data.Data[0];
                let modifiedResponseData = { ...responseData }; // Clonar el objeto original
                modifiedResponseData.responsable = responsable; // Agregar la nueva propiedad
                arrayResponseData = [
                  ...arrayResponseData,
                  [modifiedResponseData],
                ];
                arrayResponseData = response.data.Data;
              }
            }
          }
        }

        arrayResponseData.forEach((tarea: iListTaskHumanUserId) => {
          // Busca si hay algún caso con el mismo caseId que la tarea actual
          const casoCorrespondiente = arrayCasosActivoPorId.find(
            (caso: iCasoActivo) => caso.id === tarea.caseId,
          );
          // Si se encuentra un caso correspondiente, asigna su responsable a la tarea
          if (casoCorrespondiente) {
            tarea.responsable = casoCorrespondiente.Usuario; // Aquí debes poner el campo correspondiente
          } else {
            tarea.responsable = "no hay responsable";
          }
        });

        const mockData: any = mock_Json;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let ordenarLista = [...arrayResponseData];
          ordenarLista.sort(ordenarTareas);

          ordenarLista = procesarPrioridades(ordenarLista);
          ordenarLista = ordenarLista.map(
            (e: {
              archivedDate: string;
              reached_state_date: string;
              last_update_date: string;
              assigned_date: string;
              dueDate: string;
            }) => ({
              ...e,
              assigned_date: formatearFechaCustom(e.assigned_date),
              dueDate: formatearFechaCustom(e.dueDate),
              archivedDate: formatearFechaCustom(e.archivedDate),
              reached_state_date: formatearFechaCustom(e.reached_state_date),
              last_update_date: formatearFechaCustom(e.last_update_date),
            }),
          );

          let listaFormateada =
            await procesarTareasAbiertasPorIdUsuario(ordenarLista);
          dispatch(
            setListaTareasAbiertasPorIdUsuario({
              datos: listaFormateada,
              numPagina: NumPagina,
            }),
          );
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearListaTareasAbiertasPorIdUsuario =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(
        setListaTareasAbiertasPorIdUsuario({
          datos: [],
          numPagina: 0,
        }),
      );
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setMensaje(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setListaTareasAbiertasPorIdUsuario,
  getListaTareasAbiertasPorIdUsuario,
  setClearListaTareasAbiertasPorIdUsuario,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
} = listaTareasAbiertasPorIdUsuarioSlice.actions;

export default listaTareasAbiertasPorIdUsuarioSlice.reducer;
